import { fonts } from "../globals/fonts";

const size = {
  xs: {
    fontSize: fonts.sizes.xs,
    lineHeight: "24px",
    borderRadius: "6px",
  },
  sm: {
    fontSize: fonts.sizes.sm,
    lineHeight: "24px",
    borderRadius: "6px",
  },
  md: {
    fontSize: fonts.sizes.md,
    lineHeight: "32px",
    borderRadius: "8px",
  },
  lg: {
    fontSize: fonts.sizes.lg,
    lineHeight: "40px",
    borderRadius: "10px",
  },
};

export const link = {
  size,
};
